import { render, staticRenderFns } from "./PhpManagerList.vue?vue&type=template&id=39bcb272&"
import script from "./PhpManagerList.vue?vue&type=script&lang=js&"
export * from "./PhpManagerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39bcb272')) {
      api.createRecord('39bcb272', component.options)
    } else {
      api.reload('39bcb272', component.options)
    }
    module.hot.accept("./PhpManagerList.vue?vue&type=template&id=39bcb272&", function () {
      api.rerender('39bcb272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Php/PhpManager/PhpManagerList.vue"
export default component.exports